export default "__VITE_ASSET__De5D72QC__"